module.exports = __webpack_public_path__ + "static/media/ma_profile_icon.6d42d5a9.svg";